import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import md5 from 'js-md5';
import { refreshToken, ssoOutLogin } from '@/api/modules/auth';
Vue.use(VueRouter);
import iframeServe from '@/utils/iframe-serve';

const routes = [
  // 对外系统iframe登录框
  // {
  //   path: '/',
  //   name: 'SSORedirect',
  //   component: () => import('@/views/SSORedirect.vue')
  // },
  // {
  //   path: '/',
  //   name: 'Home',
  //   component: () => import('@/views/Home.vue'),
  //   meta: {
  //     requiresAuth: false
  //   } // 标记需要认证的路由
  // },
  // 公司系统登录页
  {
    path: '/',
    name: 'SSOCallback',
    component: () => import('@/views/SSOCallback.vue')
  },
  //对外系统iframe登录框
  {
    path: '/sso-redirect',
    name: 'SSORedirect',
    component: () => import('@/views/SSORedirect.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      };
    }
  },
  linkExactActiveClass: 'isactive',
  routes
});

const getQueryParam = param => {
  if (!window.location.search) {
    let reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
    if (window.location.hash.indexOf('?') < 0) return null;
    let r = window.location.hash.split('?')[1].match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  } else {
    let reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURIComponent(r[2]);
    return null;
  }
};

router.beforeEach(async (to, from, next) => {
  // const authStore = useAuthStore();
  let relogin = getQueryParam('relogin');
  if (!relogin) {
    console.log('-----75----');
    try {
      const res = await refreshToken({
        noneStr: Date.now(),
        signV1: md5(`${Date.now().toString()}`)
      });
      if (res.data.code == 200) {
        if (res.data.data) {
          let para = {
            token: res.data.data,
            uri: getQueryParam('uri') || 'https://www.yunqingsmart.com'
          };
          new iframeServe(
            'iframes',
            para,
            'setCook',
            '8c41392a7642d7af0720f62a8646de56'
          );
          if (getQueryParam('uri')) {
            console.log('token存在准备回跳');
            // location.href = getQueryParam('uri');
          } else {
            location.href = 'https://www.yunqingsmart.com';
          }
        } else {
          next();
        }
      } else {
        next();
      }
    } catch (error) {
      next();
    }
  } else {
    console.log('-----109----');
    try {
      const res = await ssoOutLogin({
        noneStr: Date.now(),
        signV1: md5(`${Date.now().toString()}`)
      });
      if (res.data.code == 200) {
        new iframeServe(
          'iframes',
          false,
          'removeCook',
          '8c41392a7642d7af0720f62a8646de56'
        );
        next();
      }
    } catch (error) {
      next();
    }
  }

  // const requiresAuth = to.meta.requiresAuth;
  // if (requiresAuth) {
  //   if (!store.state.token) {
  //     sessionStorage.setItem('target_url', to.fullPath);
  //     next('/sso-redirect'); // 触发SSO认证
  //   } else {
  //     if (to.path == '/sso-redirect') {
  //       next('/');
  //     }
  //     next();
  //   }

  // 检查令牌有效性
  // const isTokenValid = await store.dispatch.checkToken();
  // if (isTokenValid) {
  //     next(); // 令牌有效，允许访问
  // } else {
  //     // 令牌无效，记录目标地址后跳转至SSO
  //     sessionStorage.setItem('target_url', to.fullPath);
  //     next('/sso-redirect'); // 触发SSO认证
  // }
  // } else {
  //   next(); // 无需认证的路由直接放行
  // }
});

// 重复点击路由报错
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default router;
